import Backbone, {ViewOptions} from 'backbone';

import {Sequence} from 'components/Sequence';
import {SliceMapType} from 'constants/MapsConstants';
import Annotation from 'molbio/annotations/backbone/Annotation';
import PolymerAnnotationsView, {PolymerAnnotationsViewModel} from 'molbio/maps/linear/PolymerAnnotationsView';
import Slice from 'molbio/maps/linear/Slice';
import Type from 'molbio/maps/Type';
import * as vo from 'settings/visibility-options/VisibilityOptions';

export interface SequenceAnnotationsViewModel extends PolymerAnnotationsViewModel<Sequence> {
  getAnnotations(slice: Slice): {
    total: Array<Annotation>;
    visible: Array<Annotation>;
    shown: Array<Annotation>;
  };
  polymer(): Sequence;
}

class AnnotationsView extends PolymerAnnotationsView<Sequence, SequenceAnnotationsViewModel, Annotation> {
  constructor(...args: Array<ViewOptions<Backbone.Model> | undefined>) {
    super(...args);
    this.className = 'annotations';
    this.setting = vo.ANNOTATIONS.name;
  }

  getData(start: number, end: number): Array<Annotation> {
    let shown;
    const sequence = this.model.polymer();

    // minimap case
    if (this.mapType === SliceMapType.minimap) {
      const annotationsInfo = this.model.getAnnotations(this.slice);
      const {total, visible} = annotationsInfo;
      ({shown} = annotationsInfo);
      this.model.set({totalA: total.length, visibleA: visible.length, shownA: shown.length});
    } else {
      // nonminimap case
      shown = sequence.annotations().slice(start, end);
    }
    return shown;
  }

  _registerAnnotationListeners(): void {
    const annotations = this.model.polymer().annotations();
    this.listenTo(annotations, 'change:hover change:selected', this.handleHoverSelect.bind(this));
    this.listenTo(annotations, 'click', this.pieceClickHandler.bind(this));
  }

  getResiduesType(): Type {
    return this.model.get('layout').DNA.get('type');
  }
}

export default AnnotationsView;
